module.exports = __webpack_public_path__ + "static/dgraph3x-8c231f37bf342905c1ad220795f854f7.png";